import React from 'react'
import './RegistrationPage.css'
import registerHeader from 'src/assets/images/trovity.svg'
import loginbannerimg from 'src/assets/images/trovity_banner.svg'

const RegistrationPage = (props) => {
  return (
    <div className='OuterBox' data-test='outerBox'>
      <div className='box1'>
        <div className='image1'>
          <img
            data-test='trovityImage'
            src={loginbannerimg}
            width={'100%'}
            alt={'loginbannerimg'}
          />
        </div>
        <div className='textCoveredDiv'>
          <p className='textCoveredP' data-test='textCovered'>
            <b>Are You Covered?</b>
          </p>
        </div>
        <div className='textDiv'>
          <p className='textP' data-test='welcomeText'>
            Welcome to the most secured platform to manage all your insurances
            at one go. Insurance simplified.
          </p>
        </div>
        <div className='buttonDiv'>
          <button className='buttonTag' data-test='clickButton'>
            Click Here Link
          </button>
        </div>
      </div>
      <div className='box2'>
        <div>
          <div className='image2Div'>
            <img
              data-test='box2Image'
              src={registerHeader}
              width={'60%'}
              alt={'registerHeader'}
            />
          </div>
          {props?.children}
        </div>
      </div>
    </div>
  )
}

export default RegistrationPage
